import type { ReactNode } from 'react';
import { isLocalDevelopment } from '@onramp/utils/environment/sharedEnv';
import { getCustomLogger } from '@onramp/utils/logger';
import { fetchWithCommonHeaders } from '@onramp/utils/requests';
import type { MockData } from '@cbhq/data-layer';
import { createGraphqlEnvironment, GraphqlProvider } from '@cbhq/data-layer';

type UnauthedGraphqlProviderProps = {
  children: ReactNode;
};

let fieldLevelMockData: MockData[] = [];

if (isLocalDevelopment) {
  try {
    // eslint-disable-next-line global-require
    fieldLevelMockData = require('./fieldOverrides').fieldOverrides as MockData[];
  } catch (e) {
    if (!Array.isArray(fieldLevelMockData)) {
      fieldLevelMockData = [];
    }
  }
}

const graphqlEnvFieldLevelMockConfig = {
  featureFlags: {
    enableFieldLevelMocker: true,
  },
  interceptors: {
    fieldLevelMockerConfig: {
      mockData: fieldLevelMockData,
    },
  },
};

const unauthedGraphqlEnv = createGraphqlEnvironment({
  graphqlUrl: '/graphql/query',
  networkFetch: fetchWithCommonHeaders,
  logger: getCustomLogger('UnAuthedGraphqlProvider'),
  // Add support for field level mocking in local dev mode
  ...(isLocalDevelopment && graphqlEnvFieldLevelMockConfig),
  // Other options to TBD - see https://github.cbhq.net/mono/repo/blob/master/eng/shared/react/data-layer/docs/api.md#graphql-environment--provider
});

export const UnauthedGraphqlProvider = ({ children }: UnauthedGraphqlProviderProps) => {
  return <GraphqlProvider environment={unauthedGraphqlEnv}>{children}</GraphqlProvider>;
};
